import SjEditor from './sj-editor/sj-editor'
import foreignRadio from './foreign-base-radio/foreign-base-radio'
import rotatableImg from './img-file/rotatable-img'

const components = [
  SjEditor,
  rotatableImg
]

const install = function (Vue, axios, opts = {}) {
  //注入axios;
  // Vue.prototype.$http = axios;
  const AVUE = {
    clientHeight: document.documentElement.clientHeight
  };
  components.map(component => {
    Vue.component(component.name, component);
  });

  AVUE.size = opts.size || '';
  Vue.prototype.$AVUE = AVUE;
}

if (typeof window !== 'undefined' && window.Vue && window.axios) {
  install(window.Vue, window.axios);
}

export default {
  version: '1.0.0',
  SjEditor
}